import type {
  GenericTrackingEvent,
  GTMEventGlycerinDisplayOverlay,
} from '@packages/tracking/src/types/events';
import type { GlycerinDisplayBasePayload } from '@packages/tracking/src/types/payloads';

export interface DispatchDisplayOverlayTrackingProps {
  /** The event dispatcher. */
  eventDispatcher: <T extends GenericTrackingEvent>(event: T) => void;
  /** Optional click tracking properties. */
  displayTrackingProps: GlycerinDisplayBasePayload;
}

/**
 * Dispatches overlay tracking event(s).
 */
export const dispatchDisplayOverlayTracking = (props: DispatchDisplayOverlayTrackingProps) => {
  const { eventDispatcher, displayTrackingProps } = props;
  const { category, label, detail, placement, variantIds, custom } = displayTrackingProps;

  eventDispatcher<GTMEventGlycerinDisplayOverlay>({
    event: 'DisplayOverlay',
    DisplayOverlayData: {
      category: !category ? 'display-overlay' : category,
      label,
      detail,
      placement,
      variantIds,
      custom,
    },
  });
};
